import React from 'react';
import {BrowserRouter, Routes, Route} from 'react-router-dom'
import Login from './components/Login'
import Home from './components/Home'
import ResetPassword from './components/ResetPassword';
import NewPassword from './components/NewPassword';

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Login />}/>
        <Route path='/home' element={<Home />}/>
        <Route path='/resetPassword' element={< ResetPassword/>} />
        <Route path='/reset-password/:token' element={< NewPassword/>} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
